// Assistant Reducer

const initialState = {
  // Chat state
  messages: [],
  isTyping: false,
  chatError: null,

  isAssistant: false,
  isExpandChat: false,

  // Thread state
  threads: [],
  currentThreadId: null,
  threadMessages: {},
  threadsLoading: false,

  // MCP state
  mcpServers: [],
  connectedServers: [],
  mcpError: null,
  executingTool: null,
  toolExecutionResult: null,
  isLoading: false
};

const AssistantReducer = (state = initialState, action) => {
  switch (action.type) {
    // Chat Actions
    case 'SEND_MESSAGE':
      return {
        ...state,
        messages: [...state.messages, {
          id: Date.now(),
          text: action.payload,
          sender: 'user',
          timestamp: new Date().toISOString()
        }],
        chatError: null
      };

    case 'RECEIVE_MESSAGE':
      return {
        ...state,
        messages: [...state.messages, {
          id: Date.now(),
          text: action.payload.text || action.payload,
          sender: 'assistant',
          timestamp: new Date().toISOString(),
          ...action.payload
        }],
        isTyping: false
      };

    case 'SET_TYPING':
      return {
        ...state,
        isTyping: action.payload
      };

    case 'CLEAR_MESSAGES':
      return {
        ...state,
        messages: [],
        chatError: null
      };

    case 'SET_CHAT_ERROR':
      return {
        ...state,
        chatError: action.payload,
        isTyping: false
      };

    // Thread Actions
    case 'SET_THREADS':
      return {
        ...state,
        threads: action.payload,
        threadsLoading: false
      };

    case 'SET_ASSISTANT':
      return { ...state, isAssistant: action.payload }

    case 'SET_EXPANDE_CHAT':
      return { ...state, isExpandChat: action.payload }

    case 'SET_CURRENT_THREAD':
      return {
        ...state,
        currentThreadId: action.payload
      };

    case 'SET_THREAD_MESSAGES':
      return {
        ...state,
        threadMessages: {
          ...state.threadMessages,
          [action.payload.threadId]: action.payload.messages
        },
        messages: action.payload.messages || []
      };

    case 'SET_THREADS_LOADING':
      return {
        ...state,
        threadsLoading: action.payload
      };

    case 'REMOVE_THREAD':
      const { [action.payload]: removed, ...remainingMessages } = state.threadMessages;
      return {
        ...state,
        threads: state.threads.filter(thread => thread._id !== action.payload),
        threadMessages: remainingMessages,
        currentThreadId: state.currentThreadId === action.payload ? null : state.currentThreadId
      };

    // MCP Server Actions
    case 'SET_ALL_MCP_SERVERS':
      return {
        ...state,
        mcpServers: action.payload,
        connectedServers: action.payload.filter(server => server['connected']).map(server => server['name']),
        mcpError: null
      };

    case 'SET_EXECUTING_TOOL':
      return {
        ...state,
        executingTool: action.payload,
        toolExecutionResult: null
      };

    case 'SET_ASSISTANT_LOADING':
      return {
        ...state,
        isLoading: action.payload
      };

    case 'SET_MCP_ERROR':
      return {
        ...state,
        mcpError: action.payload,
        isLoading: false
      };

    // Tool execution result
    case 'SET_TOOL_EXECUTION_RESULT':
      return {
        ...state,
        executingTool: null,
        toolExecutionResult: action.payload
      };

    // Update message feedback
    case 'UPDATE_MESSAGE_FEEDBACK_SUCCESS':
      return {
        ...state,
        messages: state.messages.map(msg =>
          msg.messageId === action.payload.messageId
            ? { ...msg, feedback: action.payload.feedback }
            : msg
        ),
        threadMessages: Object.keys(state.threadMessages).reduce((acc, threadId) => {
          acc[threadId] = state.threadMessages[threadId].map(msg =>
            msg.messageId === action.payload.messageId
              ? { ...msg, feedback: action.payload.feedback }
              : msg
          );
          return acc;
        }, {})
      };

    // Reset state on logout or purge
    case 'LOGOUT':
    case 'persist/PURGE':
      return initialState;

    default:
      return state;
  }
};

export default AssistantReducer;